/**
 * Accessors for the Production Engineer (PE) assigned to an org.
 *
 * The list endpoint (csp/get_all_of_business_type) and the single-org detail
 * endpoint return different shapes, mirroring the same split that already
 * exists for CS:
 *   list   -> production_engineer_id + flat production_engineer_name
 *   detail -> production_engineer_id + nested production_engineer object
 *
 * On the list endpoint the backend only sets production_engineer_name when an
 * id is present, so for an unassigned org the key is absent entirely rather
 * than null. Always go through these helpers instead of reading the fields
 * directly.
 */

export const pe_id_for_store = (store) => {
	return store && store.production_engineer_id ? store.production_engineer_id : ''
}

export const pe_name_for_store = (store) => {
	if (!store) return ''
	if (store.production_engineer_name) return store.production_engineer_name
	if (store.production_engineer && store.production_engineer.first_name) return store.production_engineer.first_name
	return ''
}

/**
 * Options for a PE filter dropdown, built from the customer_success_executive/get
 * roster. Only reps flagged `pe` can be assigned as a Production Engineer.
 */
export const pe_filter_options = (cs_executives) => {
	return cs_executives && cs_executives.length ? cs_executives.filter(x => x.pe).map(x => { return { value: x.user_id, label: x.first_name } }) : []
}
